/**
 * BatchGeoContactOwner is a module that manages a contact form that pops open
 * in a modal that will send an email on behalf of the current user. It does a
 * check that the current user isnt  bot and validates the email as well.
 */
(function (window) {
  var strings = BatchGeoStrings.getStringsForComponent("BatchGeoContactOwner");
  var BatchGeoContactOwner = {
    /**
     * Will disable or enable the submission of the form based on the
     * boolean given.
     *
     * @param {boolean} isDisabled If true, sets the form to disabled. If
     * false will let the form submit
     */
    toggleFormDisabled: function (isDisabled) {
      this.$form.find("[type=submit]").attr("disabled", isDisabled);
    },

    /**
     * Given a message, it will display that message as an error on the form
     * and will enable the form to submit again.
     * @param {string} message The error message to display to the user
     */
    reportError: function (message) {
      this.$form.find(".batchgeo-contact-owner-error").html(message).show();
      this.toggleFormDisabled(false);
      $.colorbox.resize();
    },

    /**
     * Manages the form submission event. It validates the form, checks the
     * email against SendGrid and then executes captcha to prevent bots.
     *
     * @param {Event} event Takes a DOM event object. Expects preventDefault
     * and stopPropagation to be on the event object.
     */
    handleSubmit: function (event) {
      event.preventDefault();
      event.stopPropagation();

      this.toggleFormDisabled(true);

      var formObject = BatchGeo.formValuesToObject(this.$form);

      // Make sure there's some substance here and not just a "Hey!"
      if (formObject.message.length < 10) {
        return this.reportError(strings.get("ERROR_SHORT_MESSAGE"));
      }

      // We need to try to prevent obvious spammers and also typo'd emails
      // so we use the testEmail function that validates against the
      // SendGrid Bounces API
      BatchGeoApi().testEmail(
        formObject.email,
        function (xhr, statusText) {
          if (statusText === "error") {
            this.reportError(strings.get("ERROR_EMAIL_VALIDATION_PROBLEM"));
          } else if (!xhr.responseJSON.emailValid) {
            this.reportError(strings.get("ERROR_EMAIL_INVALID"));
          } else {
            this.batchGeoCaptcha.execute();
          }
        }.bind(this),
      );
    },

    /**
     * Handles the captcha response. It expects a token given to it to pass
     * to the backend API from the captcha.
     *
     * @param {string} token A token passed from the captcha callback
     */
    handleCaptcha: function (token) {
      var self = this;
      var formObject = BatchGeo.formValuesToObject(this.$form);
      BatchGeoApi().emailOwner(
        {
          message: formObject.message,
          email: formObject.email,
          mapId: BatchGeoStore.getState().App.mapId,
          token: token,
        },
        function () {
          self.handleServerResponse.apply(self, arguments);
        },
      );
    },

    /**
     * Handles the response from the emailOwner endpoint. If there's an
     * error it will enable the form again and display the error to the user
     * and if successful will show the success message in a new modal.
     *
     * @param {object} xhr An XHR response object. It expects responseJSON
     * to display the error message.
     *
     * @param {string} statusText A string representation if the request was
     * successful or not. Expects a string of "error" if anything >3xx is
     * returned to show the error message.
     */
    handleServerResponse: function (xhr, statusText) {
      if (statusText === "error") {
        this.reportError(xhr.responseJSON.error);
        this.toggleFormDisabled(false);
      } else {
        this.$form.addClass("batchgeo-contact-owner-success").html([
          $("<h2 />", { text: strings.get("SUCCESS_MESSAGE") }),
          $("<button />", {
            class: "button green confirm-btn",
            type: "button",
            text: strings.get("CLOSE_BUTTON"),
            click: $.colorbox.close,
          }),
        ]);
        $.colorbox.resize();
      }
    },

    /**
     * Renders the contact owner form in a modal and initializes the captcha
     */
    render: function () {
      this.$form = $("<form />", {
        class: "batchgeo-contact-owner",
        submit: this.handleSubmit.bind(this),
      });

      this.batchGeoCaptcha = new window.BatchGeoCaptcha({
        container: this.$form,
        callback: this.handleCaptcha.bind(this),
      });

      this.$form.append([
        $("<h2 />", { text: strings.get("FORM_TITLE") }),
        $("<p />", { text: strings.get("FORM_BODY") }),
        $("<div />", {
          html: [
            $("<label />", { text: strings.get("FORM_MESSAGE_LABEL") }),
            $("<textarea />", { name: "message", required: true }),
          ],
        }),
        $("<div />", {
          html: [
            $("<label />", { html: strings.get("FORM_EMAIL_LABEL") }),
            $("<input />", {
              name: "email",
              type: "email",
              value: BatchGeoStore.getState().App.currentUser.email,
              required: true,
            }),
          ],
        }),
        $("<p />", { class: "batchgeo-contact-owner-error" }),
        $("<button />", {
          type: "submit",
          name: "submit",
          class: "button green confirm-btn",
          text: strings.get("FORM_SUBMIT_BUTTON"),
        }),
      ]);

      $.colorbox({
        html: $("<div />", {
          class: "dialog-message",
          html: this.$form,
        }),
        width: !BatchGeoDevices.is("mobile") ? undefined : "95%",
        fixed: true,
        closeButton: false,
        transition: "none",
        className: "custom-dialog",
      });

      // Check for the first input or textarea and auto focus it for easy typing
      this.$form.find("input,textarea").first().focus();
    },
  };

  window.BatchGeoContactOwner = BatchGeoContactOwner;
})(window);
